import React, { useEffect } from "react";
import "./Home.css";
import bannerimg1 from "../assets/banner_img5.png";
import bannerimg2 from "../assets/banner_img2.svg";
import bannerimg3 from "../assets/banner_img3.svg";
import bannerimg4 from "../assets/banner_img4.png";
import callicon from "../assets/call_icon.svg";
import whatsappicon from "../assets/WatSapp.svg";
import mailicon from "../assets/mail_icon.svg";
import linkicon from "../assets/link_icon.svg";
import loactionicon from "../assets/loaction_icon.svg";
import socialicon1 from "../assets/social_icon1.svg";
import socialicon2 from "../assets/social_icon2.svg";
import socialicon3 from "../assets/social_icon3.svg";
import socialicon4 from "../assets/social_icon4.svg";
import socialicon5 from "../assets/social_icon5.svg";
import socialicon6 from "../assets/social_icon6.svg";
import socialicon7 from "../assets/social_icon7.svg";
import socialicon8 from "../assets/social_icon8.svg";
import socialicon9 from "../assets/social_icon9.svg";
import socialicon10 from "../assets/social_icon10.svg";
import socialicon11 from "../assets/social_icon11.svg";
import socialicon12 from "../assets/social_icon12.svg";
import socialicon13 from "../assets/social_icon13.svg";
import socialicon14 from "../assets/social_icon14.svg";
import socialicon15 from "../assets/social_icon15.svg";
import socialicon16 from "../assets/social_icon16.svg";
import socialicon17 from "../assets/social_icon17.svg";
import socialicon18 from "../assets/social_icon18.svg";
import socialicon19 from "../assets/social_icon19.svg";
import { animated } from "react-spring";

const ContactItem = ({ icon, children, href }) => {
    const content = (
        <>
            <div className="contact-item__icon" aria-hidden>
                {icon}
            </div>
            <div className="contact-item__text">{children}</div>
        </>
    );

    if (href) {
        return (
            <a href={href} className="contact-item fade-item" style={{ textDecoration: 'none', color: 'inherit' }}>
                {content}
            </a>
        );
    }

    return <div className="contact-item fade-item">{content}</div>;
};

const Home = () => {
    useEffect(() => {
        const items = document.querySelectorAll(".fade-item");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("show");
                    }
                });
            },
            { threshold: 0.2 }
        );

        items.forEach((item) => observer.observe(item));
        window.scrollTo(0, 0);
    }, []);
    return (
        <>
            <section className="hero">
                <div className="hero__inner">
                    <div className="hero__left">
                        <h2 className="hero__title fade-item">Contact &amp; Bookings</h2>

                        <div className="contact-list">
                            <ContactItem
                                icon={
                                    <span className="ico">
                                        <img src={callicon} alt="" />
                                    </span>
                                }
                                href="tel:07517320267"
                            >
                                Phone Number
                            </ContactItem>
                            <ContactItem
                                icon={
                                    <span className="ico">
                                        <img src={whatsappicon} alt="" />
                                    </span>
                                }
                                href="https://wa.me/07517320267"
                            >
                                WhatsApp
                            </ContactItem>
                            <ContactItem
                                icon={
                                    <span className="ico">
                                        <img src={mailicon} alt="" />
                                    </span>
                                }
                                href="mailto:apextransfersltd@gmail.com"
                            >
                                Email Address
                            </ContactItem>
                            <ContactItem
                                icon={
                                    <span className="ico">
                                        <img src={linkicon} alt="" />
                                    </span>
                                }
                                href="mailto:apextransfersltd@gmail.com"
                            >
                                Booking Link
                            </ContactItem>
                            {/* <ContactItem
                                icon={
                                    <span className="ico">
                                        {" "}
                                        <img src={loactionicon} alt="" />
                                    </span>
                                }
                            >
                                Address / Service area
                            </ContactItem> */}
                        </div>
                    </div>

                    {/* <div className="hero__right" aria-hidden>
                        <img src={bannerimg1} alt='' className='first' />
                        <img src={bannerimg4} alt='' className='second' />
                    </div> */}
                    <div className="hero__right fade-item">
                        <img src={bannerimg1} alt="" className="first" />
                        <img src={bannerimg4} alt="" className="second" />
                    </div>
                </div>
            </section>

            {/* General Highlights section */}
            <section className="highlights-section">
                <div className="highlights__inner">
                    <h3 className="highlights__title fade-item">
                        General Taxi Service Highlights
                    </h3>

                    <div className="highlights-grid d-none d-md-flex">
                        <div className="highlights-col">
                            <div className="highlight-card fade-item">
                                <span className="hl-ico">
                                    <img src={socialicon10} alt="" />
                                </span>
                                <span>
                                    24/7 availability for local and long-distance travel
                                </span>
                            </div>
                            <div className="highlight-card fade-item">
                                <span className="hl-ico">
                                    <img src={socialicon11} alt="" />
                                </span>
                                <span>Safe, clean, and well-maintained vehicles</span>
                            </div>
                            <div className="highlight-card fade-item">
                                <span className="hl-ico">
                                    <img src={socialicon12} alt="" />
                                </span>
                                <span>Professional, licensed, and courteous drivers</span>
                            </div>
                            <div className="highlight-card fade-item">
                                <span className="hl-ico">
                                    <img src={socialicon13} alt="" />
                                </span>
                                <span>Quick and reliable pick-up and drop-off</span>
                            </div>
                            <div className="highlight-card fade-item">
                                <span className="hl-ico">
                                    <img src={socialicon14} alt="" />
                                </span>
                                <span>Easy booking via phone, app, or website</span>
                            </div>
                        </div>

                        <div className="highlights-col second-col">
                            <div className="highlight-card fade-item">
                                <span className="hl-ico">
                                    <img src={socialicon15} alt="" />
                                </span>
                                <span>
                                    Competitive and transparent pricing (no hidden charges)
                                </span>
                            </div>
                            <div className="highlight-card fade-item">
                                <span className="hl-ico">
                                    <img src={socialicon16} alt="" />
                                </span>
                                <span>
                                    GPS-enabled vehicles for accurate navigation and tracking
                                </span>
                            </div>
                            <div className="highlight-card fade-item">
                                <span className="hl-ico">
                                    <img src={socialicon17} alt="" />
                                </span>
                                <span>
                                    Cashless payment options (credit/debit cards, mobile wallets)
                                </span>
                            </div>
                            <div className="highlight-card fade-item">
                                <span className="hl-ico">
                                    <img src={socialicon18} alt="" />
                                </span>
                                <span>Airport transfers and scheduled rides available</span>
                            </div>
                            <div className="highlight-card fade-item">
                                <span className="hl-ico">
                                    <img src={socialicon19} alt="" />
                                </span>
                                <span>
                                    Wheelchair-accessible and child-seat options upon request
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="wrapper d-flex d-md-none">
                        <div class="scroller-container">
                            <div class="scroller-wrapper">
                                <div class="scroller-slide">
                                    <span className="hl-ico">
                                        <img src={socialicon10} alt="" />
                                    </span>
                                    <span> 24/7 availability for local and long-distance travel </span>
                                </div>
                                <div class="scroller-slide">
                                    <span className="hl-ico">
                                        <img src={socialicon11} alt="" />
                                    </span>
                                    <span>Safe, clean, and well-maintained vehicles</span>
                                </div>
                                <div class="scroller-slide">
                                    <span className="hl-ico">
                                        <img src={socialicon12} alt="" />
                                    </span>
                                    <span>Professional, licensed, and courteous drivers</span>
                                </div>
                                <div class="scroller-slide">
                                    <span className="hl-ico">
                                        <img src={socialicon13} alt="" />
                                    </span>
                                    <span>Quick and reliable pick-up and drop-off</span>
                                </div>
                                <div class="scroller-slide">
                                    <span className="hl-ico">
                                        <img src={socialicon14} alt="" />
                                    </span>
                                    <span>Easy booking via phone, app, or website</span>
                                </div>
                                <div class="scroller-slide">
                                    <span className="hl-ico">
                                        <img src={socialicon10} alt="" />
                                    </span>
                                    <span> 24/7 availability for local and long-distance travel </span>
                                </div>
                                <div class="scroller-slide">
                                    <span className="hl-ico">
                                        <img src={socialicon11} alt="" />
                                    </span>
                                    <span>Safe, clean, and well-maintained vehicles</span>
                                </div>
                                <div class="scroller-slide">
                                    <span className="hl-ico">
                                        <img src={socialicon12} alt="" />
                                    </span>
                                    <span>Professional, licensed, and courteous drivers</span>
                                </div>
                                <div class="scroller-slide">
                                    <span className="hl-ico">
                                        <img src={socialicon13} alt="" />
                                    </span>
                                    <span>Quick and reliable pick-up and drop-off</span>
                                </div>
                                <div class="scroller-slide">
                                    <span className="hl-ico">
                                        <img src={socialicon14} alt="" />
                                    </span>
                                    <span>Easy booking via phone, app, or website</span>
                                </div>
                                <div class="scroller-slide">
                                    <span className="hl-ico">
                                        <img src={socialicon10} alt="" />
                                    </span>
                                    <span> 24/7 availability for local and long-distance travel </span>
                                </div>
                                <div class="scroller-slide">
                                    <span className="hl-ico">
                                        <img src={socialicon11} alt="" />
                                    </span>
                                    <span>Safe, clean, and well-maintained vehicles</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="wrapper d-flex d-md-none">
                        <div class="scroller-container">
                            <div class="scroller-wrapper scroller-wrapper-2">
                                <div class="scroller-slide">
                                    <span className="hl-ico">
                                        <img src={socialicon15} alt="" />
                                    </span>
                                    <span> Competitive and transparent pricing (no hidden charges) </span>
                                </div>
                                <div class="scroller-slide">
                                    <span className="hl-ico">
                                        <img src={socialicon16} alt="" />
                                    </span>
                                    <span> GPS-enabled vehicles for accurate navigation and tracking </span>
                                </div>
                                <div class="scroller-slide">
                                    <span className="hl-ico">
                                        <img src={socialicon17} alt="" />
                                    </span>
                                    <span>
                                        Cashless payment options (credit/debit cards, mobile wallets)
                                    </span>
                                </div>
                                <div class="scroller-slide">
                                    <span className="hl-ico">
                                        <img src={socialicon18} alt="" />
                                    </span>
                                    <span>Airport transfers and scheduled rides available</span>
                                </div>
                                <div class="scroller-slide">
                                    <span className="hl-ico">
                                        <img src={socialicon19} alt="" />
                                    </span>
                                    <span> Wheelchair-accessible and child-seat options upon request </span>
                                </div>
                                <div class="scroller-slide">
                                    <span className="hl-ico">
                                        <img src={socialicon15} alt="" />
                                    </span>
                                    <span> Competitive and transparent pricing (no hidden charges) </span>
                                </div>
                                <div class="scroller-slide">
                                    <span className="hl-ico">
                                        <img src={socialicon16} alt="" />
                                    </span>
                                    <span> GPS-enabled vehicles for accurate navigation and tracking </span>
                                </div>
                                <div class="scroller-slide">
                                    <span className="hl-ico">
                                        <img src={socialicon17} alt="" />
                                    </span>
                                    <span>
                                        Cashless payment options (credit/debit cards, mobile wallets)
                                    </span>
                                </div>
                                <div class="scroller-slide">
                                    <span className="hl-ico">
                                        <img src={socialicon18} alt="" />
                                    </span>
                                    <span>Airport transfers and scheduled rides available</span>
                                </div>
                                <div class="scroller-slide">
                                    <span className="hl-ico">
                                        <img src={socialicon19} alt="" />
                                    </span>
                                    <span> Wheelchair-accessible and child-seat options upon request </span>
                                </div>
                                <div class="scroller-slide">
                                    <span className="hl-ico">
                                        <img src={socialicon15} alt="" />
                                    </span>
                                    <span> Competitive and transparent pricing (no hidden charges) </span>
                                </div>
                                <div class="scroller-slide">
                                    <span className="hl-ico">
                                        <img src={socialicon16} alt="" />
                                    </span>
                                    <span> GPS-enabled vehicles for accurate navigation and tracking </span>
                                </div>
                                <div class="scroller-slide">
                                    <span className="hl-ico">
                                        <img src={socialicon17} alt="" />
                                    </span>
                                    <span>
                                        Cashless payment options (credit/debit cards, mobile wallets)
                                    </span>
                                </div>
                                <div class="scroller-slide">
                                    <span className="hl-ico">
                                        <img src={socialicon18} alt="" />
                                    </span>
                                    <span>Airport transfers and scheduled rides available</span>
                                </div>
                                <div class="scroller-slide">
                                    <span className="hl-ico">
                                        <img src={socialicon19} alt="" />
                                    </span>
                                    <span> Wheelchair-accessible and child-seat options upon request </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Specialized Services section */}
            <section className="specialized-section">
                <div className="specialized__inner">
                    <div className="specialized__visual fade-item" aria-hidden>
                        <img src={bannerimg2} alt="" />
                    </div>

                    <div className="specialized__list">
                        <h3 className="specialized__title fade-item">
                            Specialized Services
                        </h3>
                        <div className="specialized-cards d-none d-md-grid">
                            <div className="spec-card fade-item">
                                <span className="spec-ico">
                                    <img src={socialicon1} alt="" />
                                </span>
                                <span>Corporate and business travel solutions</span>
                            </div>
                            <div className="spec-card fade-item">
                                <span className="spec-ico">
                                    <img src={socialicon2} alt="" />
                                </span>
                                <span>Group transport and event shuttles</span>
                            </div>
                            <div className="spec-card fade-item">
                                <span className="spec-ico">
                                    <img src={socialicon3} alt="" />
                                </span>
                                <span>Outstation trips and sightseeing tours</span>
                            </div>
                            <div className="spec-card fade-item">
                                <span className="spec-ico">
                                    <img src={socialicon4} alt="" />
                                </span>
                                <span>Parcel and document delivery service</span>
                            </div>
                            <div className="spec-card fade-item">
                                <span className="spec-ico">
                                    <img src={socialicon5} alt="" />
                                </span>
                                <span>School and staff transportation</span>
                            </div>
                        </div>
                        <div class="wrapper d-flex d-md-none">
                            <div class="scroller-container">
                                <div class="scroller-wrapper scroller-wrapper-3">
                                    <div class="scroller-slide">
                                        <span className="spec-ico">
                                            <img src={socialicon1} alt="" />
                                        </span>
                                        <span>Corporate and business travel solutions</span>
                                    </div>
                                    <div class="scroller-slide">
                                        <span className="spec-ico">
                                            <img src={socialicon2} alt="" />
                                        </span>
                                        <span>Group transport and event shuttles</span>
                                    </div>
                                    <div class="scroller-slide">
                                        <span className="spec-ico">
                                            <img src={socialicon3} alt="" />
                                        </span>
                                        <span>Outstation trips and sightseeing tours</span>
                                    </div>
                                    <div class="scroller-slide">
                                        <span className="spec-ico">
                                            <img src={socialicon4} alt="" />
                                        </span>
                                        <span>Parcel and document delivery service</span>
                                    </div>
                                    <div class="scroller-slide">
                                        <span className="spec-ico">
                                            <img src={socialicon5} alt="" />
                                        </span>
                                        <span>School and staff transportation</span>
                                    </div>
                                    <div class="scroller-slide">
                                        <span className="spec-ico">
                                            <img src={socialicon1} alt="" />
                                        </span>
                                        <span>Corporate and business travel solutions</span>
                                    </div>
                                    <div class="scroller-slide">
                                        <span className="spec-ico">
                                            <img src={socialicon2} alt="" />
                                        </span>
                                        <span>Group transport and event shuttles</span>
                                    </div>
                                    <div class="scroller-slide">
                                        <span className="spec-ico">
                                            <img src={socialicon3} alt="" />
                                        </span>
                                        <span>Outstation trips and sightseeing tours</span>
                                    </div>
                                    <div class="scroller-slide">
                                        <span className="spec-ico">
                                            <img src={socialicon4} alt="" />
                                        </span>
                                        <span>Parcel and document delivery service</span>
                                    </div>
                                    <div class="scroller-slide">
                                        <span className="spec-ico">
                                            <img src={socialicon5} alt="" />
                                        </span>
                                        <span>School and staff transportation</span>
                                    </div>
                                    <div class="scroller-slide">
                                        <span className="spec-ico">
                                            <img src={socialicon1} alt="" />
                                        </span>
                                        <span>Corporate and business travel solutions</span>
                                    </div>
                                    <div class="scroller-slide">
                                        <span className="spec-ico">
                                            <img src={socialicon2} alt="" />
                                        </span>
                                        <span>Group transport and event shuttles</span>
                                    </div>
                                    <div class="scroller-slide">
                                        <span className="spec-ico">
                                            <img src={socialicon3} alt="" />
                                        </span>
                                        <span>Outstation trips and sightseeing tours</span>
                                    </div>
                                    <div class="scroller-slide">
                                        <span className="spec-ico">
                                            <img src={socialicon4} alt="" />
                                        </span>
                                        <span>Parcel and document delivery service</span>
                                    </div>
                                    <div class="scroller-slide">
                                        <span className="spec-ico">
                                            <img src={socialicon5} alt="" />
                                        </span>
                                        <span>School and staff transportation</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Customer Benefits section */}
            <section className="customer-section">
                <div className="customer__inner">
                    <div
                        className="customer__right-visual fade-item"
                        aria-hidden
                    >
                        <img src={bannerimg3} alt="" />
                    </div>
                    <div className="customer__left">
                        <h3 className="customer__title fade-item">Customer Benefits</h3>

                        <div className="customer-list d-none d-md-grid">
                            <div className="customer-card fade-item">
                                <span className="cust-ico">
                                    <img src={socialicon6} alt="" />
                                </span>
                                <span>24/7 customer support and assistance</span>
                            </div>
                            <div className="customer-card fade-item">
                                <span className="cust-ico">
                                    <img src={loactionicon} alt="" />
                                </span>
                                <span>Real-time ride tracking and ETA updates</span>
                            </div>
                            <div className="customer-card fade-item">
                                <span className="cust-ico">
                                    <img src={socialicon7} alt="" />
                                </span>
                                <span>Loyalty discounts and referral bonuses</span>
                            </div>
                            <div className="customer-card fade-item">
                                <span className="cust-ico">
                                    <img src={socialicon8} alt="" />
                                </span>
                                <span>Multilingual drivers for tourist convenience</span>
                            </div>
                            <div className="customer-card fade-item">
                                <span className="cust-ico">
                                    <img src={socialicon9} alt="" />
                                </span>
                                <span>Safety-first policy with background-checked drivers</span>
                            </div>
                        </div>
                        <div class="wrapper d-flex d-md-none">
                            <div class="scroller-container">
                                <div class="scroller-wrapper scroller-wrapper-3">
                                    <div class="scroller-slide">
                                        <span className="cust-ico">
                                            <img src={socialicon6} alt="" />
                                        </span>
                                        <span>24/7 customer support and assistance</span>
                                    </div>
                                    <div class="scroller-slide">
                                        <span className="cust-ico">
                                            <img src={loactionicon} alt="" />
                                        </span>
                                        <span>Real-time ride tracking and ETA updates</span>
                                    </div>
                                    <div class="scroller-slide">
                                        <span className="cust-ico">
                                            <img src={socialicon7} alt="" />
                                        </span>
                                        <span>Loyalty discounts and referral bonuses</span>
                                    </div>
                                    <div class="scroller-slide">
                                        <span className="cust-ico">
                                            <img src={socialicon8} alt="" />
                                        </span>
                                        <span>Multilingual drivers for tourist convenience</span>
                                    </div>
                                    <div class="scroller-slide">
                                        <span className="cust-ico">
                                            <img src={socialicon9} alt="" />
                                        </span>
                                        <span>Safety-first policy with background-checked drivers</span>
                                    </div>
                                    <div class="scroller-slide">
                                        <span className="cust-ico">
                                            <img src={socialicon6} alt="" />
                                        </span>
                                        <span>24/7 customer support and assistance</span>
                                    </div>
                                    <div class="scroller-slide">
                                        <span className="cust-ico">
                                            <img src={loactionicon} alt="" />
                                        </span>
                                        <span>Real-time ride tracking and ETA updates</span>
                                    </div>
                                    <div class="scroller-slide">
                                        <span className="cust-ico">
                                            <img src={socialicon7} alt="" />
                                        </span>
                                        <span>Loyalty discounts and referral bonuses</span>
                                    </div>
                                    <div class="scroller-slide">
                                        <span className="cust-ico">
                                            <img src={socialicon8} alt="" />
                                        </span>
                                        <span>Multilingual drivers for tourist convenience</span>
                                    </div>
                                    <div class="scroller-slide">
                                        <span className="cust-ico">
                                            <img src={socialicon9} alt="" />
                                        </span>
                                        <span>Safety-first policy with background-checked drivers</span>
                                    </div>
                                    <div class="scroller-slide">
                                        <span className="cust-ico">
                                            <img src={socialicon6} alt="" />
                                        </span>
                                        <span>24/7 customer support and assistance</span>
                                    </div>
                                    <div class="scroller-slide">
                                        <span className="cust-ico">
                                            <img src={loactionicon} alt="" />
                                        </span>
                                        <span>Real-time ride tracking and ETA updates</span>
                                    </div>
                                    <div class="scroller-slide">
                                        <span className="cust-ico">
                                            <img src={socialicon7} alt="" />
                                        </span>
                                        <span>Loyalty discounts and referral bonuses</span>
                                    </div>
                                    <div class="scroller-slide">
                                        <span className="cust-ico">
                                            <img src={socialicon8} alt="" />
                                        </span>
                                        <span>Multilingual drivers for tourist convenience</span>
                                    </div>
                                    <div class="scroller-slide">
                                        <span className="cust-ico">
                                            <img src={socialicon9} alt="" />
                                        </span>
                                        <span>Safety-first policy with background-checked drivers</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <animated.div className="customer__right fade-item" aria-hidden>
                        <img src={bannerimg3} alt="" />
                    </animated.div>
                </div>
            </section>
        </>
    );
};

export default Home;
